import List from 'src/storage/list';
import constants from 'src/constants';

const userStatuses = constants.general.userStatus;

class AdminActiveClinicModel extends List {
  id = 'AdminActiveClinicModel';
  defaultState = () => ({
    current: 'recent',
    tab: 'active',
    pageIndex: 0,
    sortBy: {
      key: 'created',
      desc: true
    }
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'admin/clinic/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/clinic/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/clinic/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    updateStatus: {
      url: 'admin/clinic/update/status',
      validation: {
        id: 'userId',
        status: 'string',
        reason: 'string'
      },
      cancellable: true
    },
    remove: {
      url: 'admin/clinic/remove',
      validation: {
        id: 'userId'
      },
      cancellable: false
    },
    hospitals: {
      url: 'hospital/list',
      validation: {
        userId: 'userId'
      }
    },
    saveComission: {
      url: 'admin/clinic/update/comission',
      validation: {},
      cancellable: true
    }
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      specialist: this.input('specialist'),
      statusList: [
        userStatuses.approved,
        userStatuses.enabled,
        userStatuses.disabled,
        userStatuses.active
      ]
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  onChangeComission = (item, v) => {
    if (Number.isNaN(parseFloat(v))) return;
    let items = this.items();
    if (v < 0) v = 0;
    if (v > 100) v = 100;
    if (!item.serviceComission_original)
      item.serviceComission_original = item.serviceComission_original || 0;
    item.serviceComission = v;
    this.setListState({ items }, this.getCurrentId());
    clearTimeout(this.saveComissionTimeout);
    if (v.toString().length > 0)
      this.saveComissionTimeout = setTimeout(() => this.saveComission(item), 1000);
  };

  saveComission = (item) => {
    clearTimeout(this.saveComissionTimeout);
    this.cancelApi('saveComission');
    let v = item.serviceComission;
    let originalValue = item.serviceComission_original;
    this.api(
      'saveComission',
      { id: item.id, key: 'serviceComission', value: v },
      (err, res, success) => {
        let items = this.items();
        if (success) {
          item.serviceComission_original = v;
        } else {
          item.serviceComission = originalValue;
          this.setListState({ items, _updated: Date.now() }, this.getCurrentId());
        }
      }
    );
  };

  updateStatus(item, status, reason = '', cb = null, isAll = false) {
    const prevValue = item.status;
    item.status = status;
    this.setListStateSilent({ updated: Date.now() });
    this.api('updateStatus', { status, reason, id: item.id, isAll }, (err, res, success) => {
      cb && cb(err, res, success);
      if (!success) {
        item.status = prevValue;
        this.setListStateSilent({ updated: Date.now() });
      }
    });
  }

  remove = (id, cb) => {
    this.api('remove', { id }, (err, res, success) => {
      if (success) {
        this.removeItem(id);
      }
      cb && cb(err, res, success);
    });
  };
  logAsDoctor = (item) => {
    this.emit('login_as_other_user', { id: item.id });
  };
}

class AdminPendingClinicModel extends AdminActiveClinicModel {
  id = 'AdminPendingClinicModel';

  listParams(loadMore) {
    let req = {
      skip: 0,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      specialist: this.input('specialist'),
      statusList: [userStatuses.pending, userStatuses.declined, userStatuses.updated]
    };
    let query = this.input('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  loadHospitals = (userId, cb) => {
    this.api(
      'hospitals',
      {
        skip: 0,
        userId,
        limit: 200
      },
      (err, data) => {
        cb({ hospitals: !err ? data?.items || data : [] });
      }
    );
  };
  updateStatus(item, status, reason = '', cb = null) {
    this.api('updateStatus', { status, reason, id: item.id }, (err, res, success) => {
      cb && cb(err, res, success);
    });
  }
}

export const activeModel = new AdminActiveClinicModel();
export const pendingModel = new AdminPendingClinicModel();

export default activeModel;
